import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight, ChevronLeft } from 'lucide-react';
import { Language } from '@/types';
import { docsRegistry } from '../data/docs-registry';
import { prefetchDocRoute } from '../utils/prefetch-routes';

interface NovaNextStepProps {
  lang: Language;
  currentPageHref: string;
}

export const NovaNextStep: React.FC<NovaNextStepProps> = ({ lang, currentPageHref }) => {
  const isRtl = lang === 'ar';
  
  // Find current index in registry
  const currentIndex = docsRegistry.findIndex(doc => doc.href === currentPageHref);
  const nextDoc = currentIndex !== -1 && currentIndex < docsRegistry.length - 1 
    ? docsRegistry[currentIndex + 1] 
    : null;

  if (!nextDoc) return null;

  return (
    <div className="mt-16 group">
      <Link 
        to={nextDoc.href}
        onMouseEnter={() => prefetchDocRoute(nextDoc.href)}
        onFocus={() => prefetchDocRoute(nextDoc.href)}
        className={`flex flex-col md:flex-row items-center justify-between p-8 rounded-3xl bg-white/[0.02] border border-white/5 hover:border-[#7F77DD]/40 hover:bg-[#7F77DD]/5 transition-all duration-500 relative overflow-hidden ${isRtl ? 'md:flex-row-reverse' : ''}`}
      >
        {/* Decorative Background Glow */}
        <div className="absolute top-0 right-0 w-32 h-32 bg-[#7F77DD]/10 blur-[60px] translate-x-16 -translate-y-16 group-hover:bg-[#7F77DD]/20 transition-all" />
        
        <div className={`flex-1 ${isRtl ? 'text-right' : 'text-left'}`}>
          <div className="text-[10px] font-black uppercase tracking-[0.2em] text-[#7F77DD] mb-3">
            {lang === 'en' ? 'Up Next' : 'الخطوة التالية'}
          </div>
          <h3 className="text-2xl font-medium text-white mb-2 group-hover:translate-x-1 transition-transform duration-500">
            {nextDoc.title[lang]}
          </h3>
          <p className="text-sm text-slate-500 max-w-md line-clamp-1">
            {nextDoc.description[lang]}
          </p>
        </div>

        <div className="mt-6 md:mt-0 w-12 h-12 rounded-full bg-white/5 border border-white/10 flex items-center justify-center group-hover:bg-[#7F77DD] group-hover:border-[#7F77DD] transition-all duration-500">
          {isRtl ? (
            <ChevronLeft size={20} className="text-slate-400 group-hover:text-white transition-colors" />
          ) : (
            <ChevronRight size={20} className="text-slate-400 group-hover:text-white transition-colors" />
          )}
        </div>
      </Link>
    </div>
  );
};

export default NovaNextStep;
